import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import {connect} from "react-redux"
import { history } from '../../../store'

import {UserRoles} from '../../../constants'
import employeeService from '../../../services/Employee.service'
import {NavigationTo, NAVIGATION_TAB_GROUP} from "../common"

import {TabBar} from '@amzn/stencil-react-components/tabs'


class Navigation extends Component {
  constructor(props) {
    super(props);
  }

  showBrokerTab = (employee) => {
    return !employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE);
  }

  showFaqTab = (employee) => {
    return !employeeService.isWholeFoodsEmployee(employee);
  }

  getNavTabs = (t, employee) => {
    let navTabs = [];

    navTabs.push({label: t('Navigation.AtAGlanceLabel'), value: NavigationTo.AtGlance});
    navTabs.push({label: t('Navigation.StockAwardLabel'), value: NavigationTo.StockAwards});

    if (this.showBrokerTab(employee)) {
      navTabs.push({label: t('Navigation.BrokerLabel'), value: NavigationTo.AvailableBrokers});
    }

    if (this.showFaqTab(employee)) {
      navTabs.push({label: t('Navigation.FAQLabel'), value: NavigationTo.StockFAQs});
    }

    return navTabs;
  }

  onTabSelect = (value) => {
    history.push(value);
  }

  render() {
    const {t, employee, selectedTab} = this.props;
    const tabBarOptions = this.getNavTabs(t, employee);
    return (
      <TabBar
        dataTestId="navigationTabGroup"
        tabs={tabBarOptions}
        selectedTab={selectedTab}
        onTabSelect={this.onTabSelect}
        tabGroup={NAVIGATION_TAB_GROUP}
      />
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  selectedTab: state.router.location.pathname
})

export default connect(mapState)(withTranslation('translationsV2')(Navigation))
